import type {Languages} from '~/types/domain/Languages';
import type {TranslationKeySuffix} from '#build/i18n';

export type LanguageItem = {
    code: string;
    name: string;
    level: TranslationKeySuffix<'profile.new.language.level.*'>;
};

export function toLanguageItems(languages: Languages): LanguageItem[] {
    return languages.items.map((language) => {
        return {
            code: language.language.code,
            name: language.language.name,
            level: language.level,
        };
    });
}
